export const menus = [
  {
    name: "讨论",
    icon: "detail_discuss",
    value: "DC"
  },
  {
    name: "团队",
    icon: "detail_group",
    value: "TEAM"
  },
  {
    name: "日志",
    icon: "detail_journal",
    value: "LOG"
  },
  {
    name: "审批历史",
    icon: "detail_journal",
    value: "HIS"
  }
]

export const verifyResultMap = {
  pass: "审批通过",
  reject: "审批驳回",
  recalled: "审批撤回"
}

export const verifyStateMap = {
  已驳回: {
    color: "#FD6565",
    icon: "detail_reject"
  },
  已撤回: {
    color: "#878A90",
    icon: "detail_recalled"
  },
  审批中: {
    color: "#FDA23F",
    icon: "detail_process"
  },
  已通过: {
    color: "#40d492",
    icon: "detail_pass"
  }
}

export const sendTypes = [
  { title: "按Enter发送", command: "Enter" },
  { title: "按Enter+Ctrl发送", command: "Enter+Ctrl" }
]

export const operations = [
  { title: "删除", command: "delete", icon: "detail_delete" },
  { title: "回复", command: "reply", icon: "detail_reply" }
]

export const emojis = [
  "😀",
  "😄",
  "😅",
  "🤣",
  "😂",
  "😉",
  "😊",
  "😍",
  "😘",
  "😜",
  "😝",
  "😏",
  "😒",
  "🙄",
  "😔",
  "😴",
  "😷",
  "🤮",
  "🥵",
  "😎",
  "😮",
  "😰",
  "😭",
  "😱",
  "😩",
  "😡",
  "💀",
  "👽",
  "🤓",
  "🥳",
  "😺",
  "😹",
  "😻",
  "🤚",
  "💩",
  "👍",
  "👎",
  "👏",
  "🙏",
  "💪",
  "👻",
  "🙈",
  "🙉",
  "🙊",
  "🐒"
]

export const logTitleMap = {
  CREATE: "【创建】了记录",
  UPDATE: "【编辑】了记录",
  DELETE: "【删除】了记录",
  RESTORE: "【恢复】了记录",
  VERIFY: "【审批】了记录",
  VERIFY_CHANGE_CANDIDATES: "【更改】了审批人",
  VERIFY_RECALL: "【撤回】了审批",
  LOCK: "【锁定】了记录",
  UNLOCK: "【解锁】了记录",
  PRINT: "【打印】了记录",
  CHANGE_OWNER: "【更改】了负责人",
  CHANGE_PART: "【更改】了参与人",
  FILL: "【填写】了记录",
  BUTTON: "触发了按钮",
  SET_PROJECT: "【关联】了项目"
}
